import * as React from "react";

import { cn } from "@/lib/utils";
import { badgeVariants } from "@/components/ui/utils/variants-simple";

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "secondary" | "destructive" | "outline" | "success" | "warning";
}
function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants.generate({ variant }), className)} {...props} />;
}

export { Badge };
